import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    className: "icon",
    style: {
      height: "1em",
      width: "1em"
    }
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5",
    transform: "translate(1 1)"
  }, React.createElement("path", {
    d: "M17.625.375L.375 17.625M17.625 17.625L.375.375"
  })));
});